/**
 * Copy for the toast shown when a partner has the PDF fallback off and no
 * partner PDF is available (AR-7883).
 *
 * It lives here, apart from the component, for two reasons. It is the whole
 * subject of AR-7883, so it deserves a test that does not need Apollo, the
 * company context, react-to-print and toast mocked to run. And the subtitle used
 * to interpolate `company?.name` unguarded, rendering the literal string
 * "Please contact undefined" whenever the company had not loaded yet, which is
 * exactly the kind of bug a pure function makes cheap to pin.
 */

// "temporarily" is deliberate: the usual cause is the partner's document not
// being ready yet, not the invoice having no PDF at all.
export const PDF_UNAVAILABLE_TITLE = 'Invoice PDF temporarily unavailable'

export const pdfUnavailableSubtitle = (companyName?: string | null): string =>
  companyName
    ? `Please contact ${companyName} for more details.`
    : 'Please contact the company that issued this invoice for more details.'
